import "core-js/modules/es6.object.define-property";

var browserCheck = function () {
  function browserCheck() {}

  Object.defineProperty(browserCheck, "isMobile", {
    get: function get() {
      return window.innerWidth < 600;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(browserCheck, "isTablet", {
    get: function get() {
      return window.innerWidth >= 600 && window.innerWidth < 900;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(browserCheck, "isDesktop", {
    get: function get() {
      return window.innerWidth >= 900;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(browserCheck, "isIPhone", {
    get: function get() {
      return /i(Phone|Pod)/i.test(window.navigator.userAgent);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(browserCheck, "isIPad", {
    get: function get() {
      return /iPad/i.test(window.navigator.userAgent);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(browserCheck, "isIOS", {
    get: function get() {
      return browserCheck.isIPad || browserCheck.isIPhone;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(browserCheck, "isAndroid", {
    get: function get() {
      return /Android/i.test(window.navigator.userAgent);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(browserCheck, "isIOSNativeApp", {
    get: function get() {
      return /app-ios-smartphone/i.test(window.navigator.userAgent);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(browserCheck, "isAndroidNativeApp", {
    get: function get() {
      return /app-android-smartphone/i.test(window.navigator.userAgent);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(browserCheck, "isNativeSmartphoneApp", {
    get: function get() {
      return browserCheck.isIOSNativeApp || browserCheck.isAndroidNativeApp;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(browserCheck, "isIOSNativeTabletApp", {
    get: function get() {
      return /app-ios-tablet/i.test(window.navigator.userAgent);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(browserCheck, "isAndroidNativeTabletApp", {
    get: function get() {
      return /app-android-tablet/i.test(window.navigator.userAgent);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(browserCheck, "isNativeTabletApp", {
    get: function get() {
      return browserCheck.isIOSNativeTabletApp || browserCheck.isAndroidNativeTabletApp;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(browserCheck, "isNativeApp", {
    get: function get() {
      return browserCheck.isNativeSmartphoneApp || browserCheck.isNativeTabletApp;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(browserCheck, "isAndroidApp", {
    get: function get() {
      return browserCheck.isAndroidNativeApp || browserCheck.isAndroidNativeTabletApp;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(browserCheck, "isIOSApp", {
    get: function get() {
      return browserCheck.isIOSNativeApp || browserCheck.isIOSNativeTabletApp;
    },
    enumerable: true,
    configurable: true
  });
  return browserCheck;
}();

export default browserCheck;
export { browserCheck };